// eslint-disable-next-line import/prefer-default-export
enum Role {
  Admin = 'ADMIN',
  QrGroup = 'QR',
  HSO = 'HSO',
  FrontOffice = 'FO',
  GroupHead = 'GH',
  Specialist = 'SPE',
  Staff = 'STF',
  Viewer = 'VIEWER',
}

export enum SpecialRole {
  Superuser = 'Superuser',
  GuidanceService = 'GS',
}

export default Role;
